
import * as d3 from 'd3';
import { useEffect, useRef } from 'react';

// var screen_width_fac = 0.675;
// var screen_height_fac = 0.85;
var screen_width_fac = 0.475;
// var screen_height_fac = 1.1;

console.log(window.innerWidth, window.innerHeight);

const View5 = (props) => {
    
    const svgRef = useRef();
    const graphRef = useRef();

    const toolTipRef = useRef();
    const mouseGRef = useRef();
    const mouseLineRef = useRef();
    const rectRef = useRef();
    const mapLayerRef = useRef();

    const tooltip = d3.select(toolTipRef.current)
        .attr('class', 'tooltip_view5')
        .style("opacity", 0);
        // .style('position', 'absolute')
        // .style("background-color", "#FFFFFF")
        // .style('padding', 6)
        // .style('display', 'none');

    const mouseG = d3.select(mouseGRef.current);
    const mouseLine = d3.select(mouseLineRef.current);
    const rect = d3.select(rectRef.current);

    const graph = d3.select(graphRef.current);
    const mapLayer = d3.select(mapLayerRef.current);

    d3.timeFormatDefaultLocale({
        "decimal": ",",
        "thousands": ".",
        "grouping": [3],
        "currency": ["€", ""],
        "dateTime": "%a %b %e %X %Y %y",
        "date": "%d.%m.%Y",
        "time": "%H:%M:%S",
        "periods": ["AM", "PM"],
        "days": ["อาทิตย์", "จันทร์", "อังคาร", "พุธ", "พฤหัสบดี", "ศุกร์", "เสาร์"],
        "shortDays": ["อา.", "จ.", "อ.", "พ.", "พฤ.", "ศ.", "ส."],
        "months": ["มกราคม", "กุมภาพันธ์", "มีนาคม", "เมษายน", "พฤษภาคม", "มิถุนายน", "กรกฎาคม", "สิงหาคม", "กันยายน", "ตุลาคม", "พฤศจิกายน", "ธันวาคม"],
        "shortMonths": ["ม.ค.", "ก.พ.", "มี.ค.", "เม.ย.", "พ.ค.", "มิ.ย.", "ก.ค.", "ส.ค.", "ก.ย.", "ต.ค.", "พ.ย.", "ธ.ค."]
      });
    
    useEffect(() => {
        if(props.graphData && props.thailandJSON && props.graphData.length != 0 && props.thailandJSON.length != 0){
            const {margin, width, height} = draw();
        }
    }, [props.graphData, props.thailandJSON, props.yAxisFormat, props.filteredData, props.CODFormat]);

    function numberWithCommas(x) {
        return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    }

    const draw = () => {

        const margin = {top: 150, right: 50, bottom: 100, left: 50};
        const width = 500 - margin.left - margin.right;
        const height = 800 - margin.top - margin.bottom;

        var xym = d3.geoMercator();

        var path = d3.geoPath().projection(xym);
    
        // Customize the projection to make the center of Thailand become the center of the map
        xym.rotate([-100.6331, -13.2]);
        xym.translate([width / 2, height / 2]);
        xym.scale(2380);

        if(props.yAxisFormat === 'ร้อยละ'){

        const colorScale_negative = d3.scaleLinear()
            .domain([-100, 0])
            .range(["green","#fff8d9"]);
        const colorScale_positive = d3.scaleLinear()
            .domain([0, 100])
            .range(["#fff8d9","red"]);
    
        mapLayer.selectAll(".province").data(props.thailandJSON.features)
            .join("path")
            .attr("class", "province")
            .attr("d", path)
            .attr('vector-effect', 'non-scaling-stroke')
            .style("fill",  feature => {
                const data = props.graphData.filter(d => {
                    return d.EngProvince === feature.properties.name;
                });
                if(data[0]){
                    if(data[0]['Excess Death Percent'] <= 0){
                        return colorScale_negative(data[0]['Excess Death Percent']);
                    } else {
                        return colorScale_positive(data[0]['Excess Death Percent']);
                    }
                }
                
                }).on("mouseover", function(event,d) {
                    var spaceX = 50;
                    var spaceY;
                    if(window.innerWidth > 1440){
                        // spaceY = 6000;
                        spaceY = window.innerHeight*5.3;
                    } else if (window.innerWidth > 500 && window.innerWidth <1440){
                            spaceY = window.innerHeight*5.5;
                    }
                    else {
                        // spaceY = 4900;
                        spaceY = window.innerHeight*6.2;
                    }
                    // if (window.innerHeight > 2048){
                    //     spaceX = 750;
                    //     spaceY = 7850;
                    // }
                    // else if (window.innerHeight > 1366 && window.innerHeight <= 2048){
                    //     spaceX = 500;
                    //     spaceY = 6150;
                    // }
                    // else if(window.innerHeight > 820 && window.innerHeight <= 1366){
                    //     spaceY = 4750;
                    // } 
                    // else if(window.innerHeight <= 820){
                    //     spaceY = 4575;
                    // } else {
                    //     spaceY = 4075;
                    // }
                    console.log(spaceY);
                    const data = props.graphData.filter(data => {
                        return data.EngProvince === d.properties.name;
                    });
                    tooltip.transition()
                    .duration(250)
                    .style("opacity", 1);
                    tooltip.html(() => {
                        if(data[0]['PROVINCE'] != undefined){
                            return "<p><strong>" + data[0]['PROVINCE'] + "</strong></p>" 
                            // "<table><tbody><tr><td class='wide'>Smoking rate in 1996:</td><td>" + formatPercent((d.properties.years[1996][0].rate)/100) + "</td></tr>" +
                            // "<tr><td>Smoking rate in 2012:</td><td>" + formatPercent((d.properties.years[2012][0].rate)/100) + "</td></tr>" +
                            // "<tr><td>Change:</td><td>" + formatPercent((d.properties.years[2012][0].rate-d.properties.years[1996][0].rate)/100) + "</td></tr></tbody></table>"
                            + "<table><tbody><tr><td>"+ "เปอร์เซ็นต์การตายส่วนเกิน : "+numberWithCommas(Math.round((data[0]['Excess Death Percent'] + Number.EPSILON) * 100) / 100) +" %</td></tr></tbody></table>"
                        } else {
                            d3.selectAll("#tooltip")
                            .style('display', 'none');
                        }
                    }
                    )
                    // .style("left", (event.pageX + 15) + "px")
                    // .style("top", (event.pageY - 28) + "px");
                    .style('left', event.pageX + spaceX + "px")
                    .style('top', event.pageY - spaceY + "px");
                })
                .on("mouseout", function(event,d) {
                    tooltip.transition()
                    .duration(250)
                    .style("opacity", 0);
                });
            // .on("mouseover", mouseover)
            // .on("mouseout", mouseout)
            // .on("click", clicked);
        let colorProvince = [];
        let label;
        label = [
            100,95,90,85,80,75,70,65,60,55,50,45,40,35,30,25,20,15,10,5,0,
            -5,-10,-15,-20,-25,-30,-35,-40,-45,-50,-55,-60,-65,-70,-75,-80,-85,-90,-95,-100
            ];
        
        label.forEach((d,i) => {
            if(i % 4 === 0){
                if(d <= 0){
                    colorProvince.push({'label':`${d}`, 'color': colorScale_negative(d)});
                } else {
                    colorProvince.push({'label':`${d}`, 'color': colorScale_positive(d)});
                }
            } else {
                if(d <= 0){
                    colorProvince.push({'label':'', 'color': colorScale_negative(d)});
                } else {
                    colorProvince.push({'label':'', 'color': colorScale_positive(d)});
                }
            }
        });

        props.onChange(colorProvince);
        } else {
            const colorScale_negative = d3.scaleLinear()
                .domain([props.minDeath, 0])
                .range(["green","#fff8d9"]);
            const colorScale_positive = d3.scaleLinear()
                .domain([0, props.maxDeath])
                .range(["#fff8d9","red"]);
        
            mapLayer.selectAll(".province").data(props.thailandJSON.features)
                // .enter().append("path")
                .join("path")
                .attr("class", "province")
                .attr("d", path)
                .attr('vector-effect', 'non-scaling-stroke')
                .style("fill",  feature => {
                    const data = props.graphData.filter(d => {
                        return d.EngProvince === feature.properties.name;
                    });
                    if(data[0]){
                        if(data[0]['Excess Death Number'] <= 0){
                            return colorScale_negative(data[0]['Excess Death Number']);
                        } else {
                            return colorScale_positive(data[0]['Excess Death Number']);
                        }
                    }
                    
                    }).on("mouseover", function(event,d) {
                        var spaceX = 50;
                        var spaceY;
                        if(window.innerWidth > 1440){
                            // spaceY = 6000;
                            spaceY = window.innerHeight*5.3;
                        } else if (window.innerWidth > 500 && window.innerWidth <1440){
                                spaceY = window.innerHeight*5.5;
                        }
                        else {
                            // spaceY = 4900;
                            spaceY = window.innerHeight*6.2;
                        }
                        // if (window.innerHeight > 2048){
                        //     spaceX = 750;
                        //     spaceY = 7850;
                        // }
                        // else if (window.innerHeight > 1366 && window.innerHeight <= 2048){
                        //     spaceX = 500;
                        //     spaceY = 6150;
                        // }
                        // else if(window.innerHeight > 820 && window.innerHeight <= 1366){
                        //     spaceY = 4750;
                        // } 
                        // else if(window.innerHeight <= 820){
                        //     spaceY = 4575;
                        // } else {
                        //     spaceY = 4075;
                        // }
                        console.log(spaceY);
                        const data = props.graphData.filter(data => {
                            return data.EngProvince === d.properties.name;
                        });
                        tooltip.transition()
                        .duration(250)
                        .style("opacity", 1);
                        tooltip.html(() => {
                            if(data[0]['PROVINCE'] != undefined){
                                return "<p><strong>" + data[0]['PROVINCE'] + "</strong></p>" 
                                // "<table><tbody><tr><td class='wide'>Smoking rate in 1996:</td><td>" + formatPercent((d.properties.years[1996][0].rate)/100) + "</td></tr>" +
                                // "<tr><td>Smoking rate in 2012:</td><td>" + formatPercent((d.properties.years[2012][0].rate)/100) + "</td></tr>" +
                                // "<tr><td>Change:</td><td>" + formatPercent((d.properties.years[2012][0].rate-d.properties.years[1996][0].rate)/100) + "</td></tr></tbody></table>"
                                + "<table><tbody><tr><td>"+ "จำนวนการตายส่วนเกิน : "+numberWithCommas(Math.round((data[0]['Excess Death Number'] + Number.EPSILON) * 100) / 100) +"</td></tr></tbody></table>"
                            } else {
                                d3.selectAll("#tooltip")
                                .style('display', 'none');
                            }
                        }
                        )
                        // .style("left", (event.pageX + 15) + "px")
                        // .style("top", (event.pageY - 28) + "px");
                        .style('left', event.pageX + spaceX + "px")
                        .style('top', event.pageY - spaceY + "px");
                    })
                    .on("mouseout", function(event,d) {
                        tooltip.transition()
                        .duration(250)
                        .style("opacity", 0);
                    });
                // .on("mouseover", mouseover)
                // .on("mouseout", mouseout)
                // .on("click", clicked);
            let colorProvince = [];
            let label;
            label = [
                props.maxDeath,
                ((Math.round(d3.quantile(props.filteredData, 0.999,  data => data['Excess Death Number'])+ Number.EPSILON) * 100) / 100),
                ((Math.round(d3.quantile(props.filteredData, 0.99,  data => data['Excess Death Number'])+ Number.EPSILON) * 100) / 100),
                ((Math.round(d3.quantile(props.filteredData, 0.98,  data => data['Excess Death Number'])+ Number.EPSILON) * 100) / 100),
                ((Math.round(d3.quantile(props.filteredData, 0.975,  data => data['Excess Death Number'])+ Number.EPSILON) * 100) / 100),
                ((Math.round(d3.quantile(props.filteredData, 0.95,  data => data['Excess Death Number'])+ Number.EPSILON) * 100) / 100),
                ((Math.round(d3.quantile(props.filteredData, 0.925,  data => data['Excess Death Number'])+ Number.EPSILON) * 100) / 100),
                ((Math.round(d3.quantile(props.filteredData, 0.925,  data => data['Excess Death Number'])+ Number.EPSILON) * 100) / 100),
                ((Math.round(d3.quantile(props.filteredData, 0.9,  data => data['Excess Death Number'])+ Number.EPSILON) * 100) / 100),
                ((Math.round(d3.quantile(props.filteredData, 0.875,  data => data['Excess Death Number'])+ Number.EPSILON) * 100) / 100),
                ((Math.round(d3.quantile(props.filteredData, 0.85,  data => data['Excess Death Number'])+ Number.EPSILON) * 100) / 100),
                ((Math.round(d3.quantile(props.filteredData, 0.825,  data => data['Excess Death Number'])+ Number.EPSILON) * 100) / 100),
                ((Math.round(d3.quantile(props.filteredData, 0.8,  data => data['Excess Death Number'])+ Number.EPSILON) * 100) / 100),
                ((Math.round(d3.quantile(props.filteredData, 0.775,  data => data['Excess Death Number'])+ Number.EPSILON) * 100) / 100),
                ((Math.round(d3.quantile(props.filteredData, 0.75,  data => data['Excess Death Number'])+ Number.EPSILON) * 100) / 100),
                ((Math.round(d3.quantile(props.filteredData, 0.725,  data => data['Excess Death Number'])+ Number.EPSILON) * 100) / 100),
                ((Math.round(d3.quantile(props.filteredData, 0.7,  data => data['Excess Death Number'])+ Number.EPSILON) * 100) / 100),
                ((Math.round(d3.quantile(props.filteredData, 0.675,  data => data['Excess Death Number'])+ Number.EPSILON) * 100) / 100),
                ((Math.round(d3.quantile(props.filteredData, 0.65,  data => data['Excess Death Number'])+ Number.EPSILON) * 100) / 100),
                ((Math.round(d3.quantile(props.filteredData, 0.625,  data => data['Excess Death Number'])+ Number.EPSILON) * 100) / 100),
                ((Math.round(d3.quantile(props.filteredData, 0.6,  data => data['Excess Death Number'])+ Number.EPSILON) * 100) / 100),
                ((Math.round(d3.quantile(props.filteredData, 0.575,  data => data['Excess Death Number'])+ Number.EPSILON) * 100) / 100),
                ((Math.round(d3.quantile(props.filteredData, 0.55,  data => data['Excess Death Number'])+ Number.EPSILON) * 100) / 100),
                ((Math.round(d3.quantile(props.filteredData, 0.525,  data => data['Excess Death Number'])+ Number.EPSILON) * 100) / 100),
                ((Math.round(d3.quantile(props.filteredData, 0.5,  data => data['Excess Death Number'])+ Number.EPSILON) * 100) / 100),
                ((Math.round(d3.quantile(props.filteredData, 0.475,  data => data['Excess Death Number'])+ Number.EPSILON) * 100) / 100),
                ((Math.round(d3.quantile(props.filteredData, 0.45,  data => data['Excess Death Number'])+ Number.EPSILON) * 100) / 100),
                ((Math.round(d3.quantile(props.filteredData, 0.425,  data => data['Excess Death Number'])+ Number.EPSILON) * 100) / 100),
                ((Math.round(d3.quantile(props.filteredData, 0.4,  data => data['Excess Death Number'])+ Number.EPSILON) * 100) / 100),
                ((Math.round(d3.quantile(props.filteredData, 0.375,  data => data['Excess Death Number'])+ Number.EPSILON) * 100) / 100),
                ((Math.round(d3.quantile(props.filteredData, 0.35,  data => data['Excess Death Number'])+ Number.EPSILON) * 100) / 100),
                ((Math.round(d3.quantile(props.filteredData, 0.325,  data => data['Excess Death Number'])+ Number.EPSILON) * 100) / 100),
                ((Math.round(d3.quantile(props.filteredData, 0.3,  data => data['Excess Death Number'])+ Number.EPSILON) * 100) / 100),
                ((Math.round(d3.quantile(props.filteredData, 0.275,  data => data['Excess Death Number'])+ Number.EPSILON) * 100) / 100),
                ((Math.round(d3.quantile(props.filteredData, 0.25,  data => data['Excess Death Number'])+ Number.EPSILON) * 100) / 100),
                ((Math.round(d3.quantile(props.filteredData, 0.225,  data => data['Excess Death Number'])+ Number.EPSILON) * 100) / 100),
                ((Math.round(d3.quantile(props.filteredData, 0.2,  data => data['Excess Death Number'])+ Number.EPSILON) * 100) / 100),
                ((Math.round(d3.quantile(props.filteredData, 0.175,  data => data['Excess Death Number'])+ Number.EPSILON) * 100) / 100),
                ((Math.round(d3.quantile(props.filteredData, 0.15,  data => data['Excess Death Number'])+ Number.EPSILON) * 100) / 100),
                ((Math.round(d3.quantile(props.filteredData, 0.125,  data => data['Excess Death Number'])+ Number.EPSILON) * 100) / 100),
                ((Math.round(d3.quantile(props.filteredData, 0.1,  data => data['Excess Death Number'])+ Number.EPSILON) * 100) / 100),
                ((Math.round(d3.quantile(props.filteredData, 0.075,  data => data['Excess Death Number'])+ Number.EPSILON) * 100) / 100),
                ((Math.round(d3.quantile(props.filteredData, 0.05,  data => data['Excess Death Number'])+ Number.EPSILON) * 100) / 100),
                ((Math.round(d3.quantile(props.filteredData, 0.025,  data => data['Excess Death Number'])+ Number.EPSILON) * 100) / 100),
                ((Math.round(d3.quantile(props.filteredData, 0.01,  data => data['Excess Death Number'])+ Number.EPSILON) * 100) / 100),
                ((Math.round(d3.quantile(props.filteredData, 0.0075,  data => data['Excess Death Number'])+ Number.EPSILON) * 100) / 100),
                ((Math.round(d3.quantile(props.filteredData, 0.005,  data => data['Excess Death Number'])+ Number.EPSILON) * 100) / 100),
                ((Math.round(d3.quantile(props.filteredData, 0.0025,  data => data['Excess Death Number'])+ Number.EPSILON) * 100) / 100),
                props.minDeath,
                ];
            
            label.forEach((d,i) => {
                if(i % 4 === 0){
                    if(d <= 0){
                        colorProvince.push({'label':`${numberWithCommas(d)}`, 'color': colorScale_negative(d)});
                    } else {
                        colorProvince.push({'label':`${numberWithCommas(d)}`, 'color': colorScale_positive(d)});
                    }
                } else {
                    if(d <= 0){
                        colorProvince.push({'label':'', 'color': colorScale_negative(d)});
                    } else {
                        colorProvince.push({'label':'', 'color': colorScale_positive(d)});
                    }
                }
            });

            props.onChange(colorProvince);
        }

        // var bigText = graph.append('text')
        // .classed('big-text', true);

        // Get province name
        function nameFn(d){
            return d && d.properties ? d.properties.name: null;
        }
        
        // function mouseover(d){
        //     d3.select(this).style('fill', '#f90');
        //     bigText.text(nameFn(d));
        // }
        
        // function mouseout(d){
        //     d3.select(this).style("fill", "#44aaee")
        //     // Reset province color
        //     mapLayer.selectAll('path')
        //     .style('fill', function(d){return centered && d===centered ? '#D5708B' : '#4ae';});
        //     // Set Provice name
        //     if (centered) {
        //     bigText.text(nameFn(centered));
        //     } else {
        //     bigText.text('');
        //     }
        // }
        
        // // When clicked, zoom in
        // function clicked(d) {
        //     var x, y, k;
        
        //     // Compute centroid of the selected path
        //     if (d && centered !== d) {
        //         var centroid = path.centroid(d);
        //         x = centroid[0];
        //         y = centroid[1];
        //         k = 4;
        //         centered = d;
        //     } else {
        //         x = width / 2;
        //         y = height / 2;
        //         k = 1;
        //         centered = null;
        //     }
        
        //     // Highlight the clicked province
        //     mapLayer.selectAll('path')
        //     .style('fill', function(d){return centered && d===centered ? '#D5708B' : '#44aaee';});
        
        //     // Zoom
        //     g.transition()
        //     .duration(750)
        //     .attr('transform', 'translate(' + width / 2 + ',' + height / 2 + ')scale(' + k + ')translate(' + -x + ',' + -y + ')');
        // }

        return {margin, width, height}
    }
    const update = (graphData, yAxisFormat, x, y, xAxisGroup, yAxisGroup, selectedTimeFormat, graphHeight, graphWidth) => {

}

    return ( 
        <div className="canvas map">
            <svg ref={svgRef} width={window.innerWidth*screen_width_fac} height="675">
                <g transform="translate(50,50)">
                    <g ref={mouseGRef} >
                        <path ref={mouseLineRef}/>
                       <rect ref={rectRef}/>
                    </g> 
                    <g ref={graphRef} className="graph">
                        <g ref={mapLayerRef} className="map-layer"/>
                    </g>

                </g>
            </svg>
            <div ref={toolTipRef}/>
        </div>
     );
}

export default View5;